import { FC } from 'react';

import { IconProps } from './types';

export const StatsChartV4Icon: FC<IconProps> = () => {
  return (
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 26.25V36.25H7.5V26.25H6.25ZM3.75 25.625C3.75 24.5895 4.58947 23.75 5.625 23.75H8.125C9.16053 23.75 10 24.5895 10 25.625V36.875C10 37.9105 9.16053 38.75 8.125 38.75H5.625C4.58947 38.75 3.75 37.9105 3.75 36.875V25.625Z"
        fill="#CEFFF4"
        fillOpacity="0.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.75 18.75V36.25H25V18.75H23.75ZM21.25 18.125C21.25 17.0895 22.0895 16.25 23.125 16.25H25.625C26.6605 16.25 27.5 17.0895 27.5 18.125V36.875C27.5 37.9105 26.6605 38.75 25.625 38.75H23.125C22.0895 38.75 21.25 37.9105 21.25 36.875V18.125Z"
        fill="#CEFFF4"
        fillOpacity="0.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.5 10V36.25H33.75V10H32.5ZM30 9.375C30 8.33947 30.8395 7.5 31.875 7.5H34.375C35.4105 7.5 36.25 8.33947 36.25 9.375V36.875C36.25 37.9105 35.4105 38.75 34.375 38.75H31.875C30.8395 38.75 30 37.9105 30 36.875V9.375Z"
        fill="#CEFFF4"
        fillOpacity="0.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 3.75V36.25H16.25V3.75H15ZM12.5 3.125C12.5 2.08947 13.3395 1.25 14.375 1.25H16.875C17.9105 1.25 18.75 2.08947 18.75 3.125V36.875C18.75 37.9105 17.9105 38.75 16.875 38.75H14.375C13.3395 38.75 12.5 37.9105 12.5 36.875V3.125Z"
        fill="#CEFFF4"
        fillOpacity="0.5"
      />
    </svg>
  );
};
